module.exports = __webpack_public_path__ + "img/w3_viewed_black.71eb719e.png";